// extracted by mini-css-extract-plugin
export var header = "_g2-0";